<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules">
      <el-row :gutter="20">
        <el-col
          :xs="{ span: 20 }"
          :sm="{ span: 6 }"
          :md="{ span: 6 }"
          :lg="{ span: 6 }"
        >
          <el-form-item
            :label="$l('form_label_name_en') || '评分项目英文名称'"
            prop="appraisalItemNameEn"
          >
            <el-input
              v-model="formData.appraisalItemNameEn"
              maxlength="50"
              :placeholder="$l('INDEX.tips_no_data') || '暂无数据'"
              :disabled="isViewDisabled"
              clearable
              size="medium"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col
          :xs="{ span: 20 }"
          :sm="{ span: 6 }"
          :md="{ span: 6 }"
          :lg="{ span: 6 }"
        >
          <el-form-item
            :label="$l('form_label_name') || '评分项目名称'"
            prop="appraisalItemName"
          >
            <el-input
              v-model="formData.appraisalItemName"
              maxlength="50"
              :placeholder="$l('INDEX.tips_no_data') || '暂无数据'"
              :disabled="isViewDisabled"
              clearable
              size="medium"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col
          :xs="{ span: 20 }"
          :sm="{ span: 6 }"
          :md="{ span: 6 }"
          :lg="{ span: 6 }"
        >
          <el-form-item
            :label="$l('form_label_highest_score') || '最高分值'"
            prop="appraisalItemTopScore"
          >
            <el-input-number
              v-model="formData.appraisalItemTopScore"
              :min="1"
              :max="100"
              size="medium"
              style="width: 100%"
              :disabled="isViewDisabled"
              :placeholder="$l('INDEX.tips_no_data') || '暂无数据'"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col
          :xs="{ span: 20 }"
          :sm="{ span: 6 }"
          :md="{ span: 6 }"
          :lg="{ span: 6 }"
        >
          <el-form-item
            :label="$l('form_label_status') || '是否有效'"
            prop="itemStatus"
          >
            <el-radio-group
              style="width: 100%;"
              size="medium"
              disabled
              v-model="formData.itemStatus"
            >
              <el-radio label="Y">{{
                $l('form_radio_valid') || '有效'
              }}</el-radio>
              <el-radio label="N">{{
                $l('form_radio_invalid') || '无效'
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 24 }"
          :md="{ span: 24 }"
          :lg="{ span: 24 }"
        >
          <el-form-item
            :label="$l('form_label_scoring_items') || '评分项填写说明'"
          >
            <el-input
              v-model="formData.appraiseItemDesc"
              type="textarea"
              :rows="2"
              maxlength="500"
              :placeholder="$l('INDEX.tips_no_data') || '暂无数据'"
              :disabled="isViewDisabled"
              clearable
              size="medium"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col v-if="createDataDisabled">
          <div style="font-size: 14px; color: #717171;">
            <span
              >Create：{{
                formData.createByName ? formData.createByName : '--'
              }}
              at {{ formData.createDate ? formData.createDate : '--' }}</span
            >
          </div>
          <div style="font-size: 14px; color: #717171;">
            <span
              >Modify：{{
                formData.modifyByName ? formData.modifyByName : '--'
              }}
              at {{ formData.modifyDate ? formData.modifyDate : '--' }}</span
            >
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      type: '',
      createDataDisabled: false,
      isViewDisabled: false,
      formData: {
        appraisalItemCode: '',
        appraisalGroupCode: '',
        appraisalItemName: '',
        appraisalItemNameEn: '',
        appraisalItemTopScore: '',
        sortOrder: 0,
        itemStatus: '',
        createByName: '',
        createDate: '',
        modifyByName: '',
        modifyDate: ''
      },
      rules: {
        appraisalItemName: [
          {
            required: true,
            message: this.$l('form_rule_name_cn') || '请输入中文名称',
            trigger: 'blur'
          }
        ],
        appraisalItemNameEn: [
          {
            required: true,
            message: this.$l('form_rule_name_en') || '请输入英文名称',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    // 初始化表单数据
    init() {
      this.isViewDisabled = false
      this.reset()
      this.$refs.form.resetFields()
    },
    // 加载表单数据（新增，编辑，详情）
    fromLoad(ref, detailParam = '') {
      this.init()
      this.type = ref
      if (ref === 'add') {
        this.createDataDisabled = false
        this.formData.ratingItemStatus = 'Y'
        this.formData.appraisalGroupCode = detailParam.appraisalGroupCode
      } else {
        this.createDataDisabled = true
        let param = { appraisalItemCode: detailParam.appraisalItemCode }
        this.$api.scmAppraisalItemDetailApi(param).then((res) => {
          this.formData = res.body
        })
        // 控制组件不可编辑
        if (ref === 'detail') {
          this.isViewDisabled = true
        }
      }
    },
    // 保存数据
    save() {
      if (this.type === 'add') {
        this.add()
      } else if (this.type === 'edit') {
        this.update()
      }
    },
    add() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.scmAppraisalItemAddApi(this.formData).then(() => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功',
              type: 'success'
            })
            // 通知父组件保存成功
            this.$emit('success')
          })
        } else {
          return false
        }
      })
    },
    update() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.scmAppraisalItemUpdateApi(this.formData).then(() => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功',
              type: 'success'
            })
            // 通知父组件保存成功
            this.$emit('success')
          })
        } else {
          return false
        }
      })
    },
    reset() {
      this.type = ''
      this.formData = {
        appraisalItemCode: '',
        appraisalGroupCode: '',
        appraisalItemName: '',
        appraisalItemNameEn: '',
        appraisalItemTopScore: '',
        sortOrder: 0,
        itemStatus: '',
        createByName: '', // 创建人
        createDate: '', // 创建时间
        modifyByName: '', // 修改人
        modifyDate: '' // 修改时间
      }
    }
  }
}
</script>
